import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button, Alert } from 'react-bootstrap';
import Loading from '../Loading';
import { getRequest, postRequest, deleteRequest } from '../../../requestUtils';
import infoIcon from '../../../../assets/images/icons/blue-info-icon.svg';
import './ProjectFitSummary.scss';
function ProjectFitSummary(_ref) {
  var proposalResourceId = _ref.proposalResourceId,
    csrfToken = _ref.csrfToken;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    projectFitSummary = _useState2[0],
    setProjectFitSummary = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    error = _useState6[0],
    setError = _useState6[1];
  var fetchProjectFitSummary = function fetchProjectFitSummary() {
    setLoading(true);
    setError('');
    getRequest('/proposals/project_fit_summary', {
      resource_id: proposalResourceId
    }).then(function (_ref2) {
      var data = _ref2.data;
      setProjectFitSummary(data);
      setLoading(false);
    })["catch"](function () {
      setError('Failed to load Project Fit Summary.');
      setLoading(false);
    });
  };
  useEffect(function () {
    fetchProjectFitSummary();
  }, []);
  var generateProjectFitSummary = function generateProjectFitSummary() {
    setLoading(true);
    setError('');
    postRequest('/proposals/generate_project_fit_summary', {
      resource_id: proposalResourceId
    }, csrfToken).then(function (_ref3) {
      var data = _ref3.data;
      setProjectFitSummary(data);
      setLoading(false);
    })["catch"](function (e) {
      setError('Failed to load Project Fit Summary.', e);
      setLoading(false);
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "body-section project-fit-summary"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fit-summary__title fw-bold text-center mb-3"
  }, "Project Fit Summary"), /*#__PURE__*/React.createElement("div", {
    className: "fit-summary__info-box  mb-3"
  }, /*#__PURE__*/React.createElement("img", {
    src: infoIcon,
    alt: "Info Icon",
    className: "info-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "info-box__message"
  }, /*#__PURE__*/React.createElement("div", null, "This summary is automatically generated using the consultant's profile details and the specific requirements of the project. It's designed to showcase how their experience and skills align with the role, highlight key strengths, and identify any areas that may require further development."), /*#__PURE__*/React.createElement("div", {
    className: "fw-bolder text-danger mt-2"
  }, "Please review and verify all details for accuracy."))), loading && /*#__PURE__*/React.createElement(Loading, null), /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, !loading && Object.keys(projectFitSummary).length === 0 && /*#__PURE__*/React.createElement(Button, {
    onClick: generateProjectFitSummary,
    variant: "primary",
    className: "mt-3"
  }, loading ? 'Generating...' : 'Generate Project Fit Summary')), !loading && Object.keys(projectFitSummary).length > 0 && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-4 mt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12 col-md-6 text-center fw-semibold"
  }, "High-Match Skills"), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12 col-md-6 text-center fw-bold d-none d-md-block fw-semibold"
  }, "Competency Gaps")), projectFitSummary.strong_fit.map(function (strongFit, i) {
    var misfit = projectFitSummary.potential_misfit[i];
    return /*#__PURE__*/React.createElement("div", {
      className: "d-flex gap-4 border-top pt-3",
      key: i
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-none d-md-flex fw-bolder text-center question-number"
    }, "".concat(i + 1)), /*#__PURE__*/React.createElement("div", {
      className: "d-flex flex-row gap-2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-sm-12 col-md-6"
    }, strongFit), /*#__PURE__*/React.createElement("div", {
      className: "d-none d-md-flex col-md-6"
    }, misfit)));
  }), projectFitSummary.potential_misfit.map(function (misfit, i) {
    return /*#__PURE__*/React.createElement("div", {
      className: "d-flex d-md-none flex-column gap-4 border-top pt-3",
      key: i
    }, i === 0 && /*#__PURE__*/React.createElement("div", {
      className: "col-12 text-center fw-semibold"
    }, "Competency Gaps"), /*#__PURE__*/React.createElement("div", {
      className: "d-flex flex-row gap-2"
    }, /*#__PURE__*/React.createElement("div", null, misfit)));
  })), error && /*#__PURE__*/React.createElement(Alert, {
    variant: "danger",
    className: "mt-3 text-center"
  }, error)));
}
ProjectFitSummary.propTypes = {
  proposalResourceId: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired
};
export default ProjectFitSummary;